import {
    BodyLargeRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    Sheet,
    YStack,
} from 'smoothie';

interface EditColorWarningSheetProps {
    isOpen: boolean;
    onClose: () => void;
    onPress: () => void;
}

const EditColorWarningSheet = ({
    isOpen,
    onClose,
    onPress,
}: EditColorWarningSheetProps) => {
    return (
        <Sheet
            isOpen={isOpen}
            onClose={onClose}
            key="edit-color-warning-sheet"
            title="Edit color"
            showCloseButton
        >
            <YStack>
                <BodyLargeRegular marginBottom={20}>
                    Changing the color of your Fruitful Cash Account will not
                    update the color of the virtual card. We recommend keeping
                    the color the same so it&apos;s easy to identify your
                    matching virtual card.
                </BodyLargeRegular>
                <Button
                    variant={ButtonVariant.SECONDARY}
                    size={ButtonSize.LARGE}
                    text="Edit color anyway"
                    onPress={onPress}
                />
            </YStack>
        </Sheet>
    );
};

export default EditColorWarningSheet;
